import React from 'react';

export default class CheckboxField extends React.Component {
  static defaultProps = {
    className: 'w-100 form-control form-control-sm',
    onChange: () => {},
    value: null,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={Boolean(this.props.value)}
          onChange={() => this.props.onChange(!this.props.value)}
        />
      </div>
    );
  }
}
